module.exports = __webpack_public_path__ + "img/quizz-step-5-4.45a9c356.jpg";